import {
  addVendor,
  getVendorsList,
  AddVendorRequest,
  deleteVendor,
  Vendor,
} from '../../../services'

export const ActionTypes = {
  ADD_VENDOR: 'ADD_VENDOR',
  FETCH_VENDORS: 'FETCH_VENDORS',
  DELETE_VENDOR: 'DELETE_VENDOR',
  VENDOR_SEARCH_RESULTS: 'VENDOR_SEARCH_RESULTS',
}

export const addVendorAction = (vendor: AddVendorRequest) => ({
  type: ActionTypes.ADD_VENDOR,
  promise: addVendor(vendor),
})

export const fetchVendorsAction = () => ({
  type: ActionTypes.FETCH_VENDORS,
  promise: getVendorsList(),
})

export const addVendorResetAction = () => ({
  type: `${ActionTypes.ADD_VENDOR}_RESET`,
})

export const deleteVendorAction = (id: number) => ({
  type: ActionTypes.DELETE_VENDOR,
  promise: deleteVendor(id),
})

export const deleteVendorResetAction = () => ({
  type: `${ActionTypes.DELETE_VENDOR}_RESET`,
})

export const searchVendor = (searchTerm: string, data: Vendor[]) => {
  if (!data?.length) return []
  return data.filter((vendor) => {
    const { address, mobile, name, gstin, email } = vendor
    const term = searchTerm?.toLowerCase()
    return (
      address?.toLowerCase().includes(term) ||
      mobile?.toLowerCase().includes(term) ||
      name?.toLowerCase().includes(term) ||
      gstin?.toLowerCase().includes(term) ||
      email?.toLowerCase().includes(term)
    )
  })
}

export const searchVendorsAction = (searchTerm: string) => {
  return (dispatch: any, getState: any) => {
    const { list } = getState().manageVendors
    const { data } = list
    const searchResults = searchVendor(searchTerm, data)
    dispatch({
      type: ActionTypes.VENDOR_SEARCH_RESULTS,
      res: { data: searchResults, searchTerm },
    })
  }
}
